import axios from "axios";
// import { LOCAL_STORAGE_KEY } from "constants/enums";
import { LOGIN } from "pages/routes/route.constant";
import qs from "qs";
import { useNavigate } from "react-router-dom";

// dotenv.config();
const bashURL = process.env.REACT_APP_SERVER_URL;

const authRequest = axios.create({
  baseURL: bashURL,
  headers: {
    "content-type": "application/json",
  },
  timeout: 60000,
  withCredentials: true,
  // paramsSerializer: (params) => qs.stringify(params),
});

const request = axios.create({
  baseURL: `${bashURL}/admin/api/v1`,
  headers: {
    "content-type": "application/json",
    // Authorization: getAuthorizationHeader(),
  },
  timeout: 60000,
  withCredentials: true,
  paramsSerializer: (params) => qs.stringify(params),
});

// request.interceptors.request.use(
//   (config: any) => {
//     console.log('config:',config)
//     if (
//       config.method === "post" ||
//       config.method === "put" ||
//       config.method === "get"
//     ) {
//       // Ensure data exists in the config
//       if (config.data) {
//         // Add the common field to the request body
//         config.data = {
//           ...config.data, // Spread existing data
//           key: GetApiKey(), // Add your common field and value
//         };
//       } else {
//         // If no data exists, create it with the common field
//         config.data = { key: GetApiKey() };
//       }
//     }
//     return config;
//   },
//   (error: AxiosError) => {
//     const navigate = useNavigate();
//     if (error.response && error.response.status === 401) {
//       // If 401 Unauthorized, redirect to login
//       navigate(LOGIN);
//     }
//     return Promise.reject(error);
//   }
// );

request.interceptors.request.use(
  (response) => response,
  (error) => {
    const navigate = useNavigate();
    if (error.response && error.response.status === 401) {
      // If 401 Unauthorized, redirect to login
      navigate(LOGIN);
    }
    return Promise.reject(error);
  }
);

export { request, authRequest };
